var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 13.0001C20.2 12.6687 20.4686 12.4001 20.8 12.4001H23.2C23.5314 12.4001 23.8 12.6687 23.8 13.0001C23.8 13.3315 23.5314 13.6001 23.2 13.6001H20.8C20.4686 13.6001 20.2 13.3315 20.2 13.0001Z",
    fill: "url(#paint0_linear_1392_6290)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.05 14.8001C20.05 14.303 20.4529 13.9001 20.95 13.9001H23.05C23.5471 13.9001 23.95 14.303 23.95 14.8001V15.7918L25.0384 17.1704C25.7908 18.1234 26.2 19.3022 26.2 20.5165V21.2152C26.2 21.497 26.1579 21.7773 26.075 22.0466C25.9791 22.3584 25.9791 22.6918 26.075 23.0036C26.1579 23.2729 26.2 23.5531 26.2 23.835V26.7895C26.2 27.0597 26.1564 27.3281 26.071 27.5845C25.9811 27.8543 25.9811 28.1459 26.071 28.4157C26.1564 28.672 26.2 28.9405 26.2 29.2107V29.8001C26.2 30.7942 25.3941 31.6001 24.4 31.6001H19.6C18.6059 31.6001 17.8 30.7942 17.8 29.8001V29.2107C17.8 28.9405 17.8436 28.672 17.929 28.4157C18.0189 28.1459 18.0189 27.8543 17.929 27.5845C17.8436 27.3281 17.8 27.0597 17.8 26.7895V23.835C17.8 23.5531 17.8421 23.2729 17.925 23.0036C18.0209 22.6918 18.0209 22.3584 17.925 22.0466C17.8421 21.7773 17.8 21.497 17.8 21.2152V20.5165C17.8 19.3022 18.2092 18.1234 18.9616 17.1704L20.05 15.7918V14.8001ZM19.1152 23.2001C19.1023 23.2525 19.0879 23.3047 19.0719 23.3565C19.0243 23.5115 19 23.6728 19 23.835V26.7895C19 26.9307 19.0228 27.071 19.0674 27.205C19.0724 27.22 19.0773 27.235 19.082 27.2501H24.918C24.9227 27.235 24.9276 27.22 24.9326 27.205C24.9772 27.071 25 26.9307 25 26.7895V23.835C25 23.6728 24.9757 23.5115 24.9281 23.3565C24.9121 23.3047 24.8977 23.2525 24.8848 23.2001H19.1152ZM19.1478 22.0001H24.8522C24.8717 21.897 24.897 21.7947 24.9281 21.6937C24.9757 21.5387 25 21.3774 25 21.2152V20.5165C25 19.5721 24.6817 18.6552 24.0965 17.914L22.9436 16.4536C22.8182 16.2948 22.75 16.0983 22.75 15.8959V15.1001H21.25V15.8959C21.25 16.0983 21.1818 16.2948 21.0564 16.4536L19.9035 17.914C19.3183 18.6552 19 19.5721 19 20.5165V21.2152C19 21.3774 19.0243 21.5387 19.0719 21.6937C19.103 21.7947 19.1283 21.897 19.1478 22.0001ZM19.0674 28.7951C19.1052 28.6818 19.1347 28.5665 19.1559 28.4501H24.8441C24.8653 28.5665 24.8948 28.6818 24.9326 28.7951C24.9772 28.9291 25 29.0695 25 29.2107V29.8001C25 30.1315 24.7314 30.4001 24.4 30.4001H19.6C19.2686 30.4001 19 30.1315 19 29.8001V29.2107C19 29.0695 19.0228 28.9291 19.0674 28.7951Z",
    fill: "url(#paint1_linear_1392_6290)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_6290",
    x1: 22,
    y1: 12.4001,
    x2: 22,
    y2: 13.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1392_6290",
    x1: 22,
    y1: 13.9001,
    x2: 22,
    y2: 31.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.52f0508fd6604704af012ca01b988979.svg";
export { ForwardRef as ReactComponent };